import { create } from 'zustand';
interface SuggestedComboStore {
  loading: boolean;
  combos: any[];
  setCombos: (combos: any[]) => void;
  setLoading: (loading: boolean) => void;
  clearCombos: () => void;
}
const useSuggestedComboStore = create(
  (set) => ({
    loading: false,
    completedCombos: [],
    toCompleteCombos: [],
    originalCombos: {}, 
    combos: [],

    setLoading: (status: boolean) => set({ loading: status }),

    setCombos: (newCombos: any[]) =>
      set({
        combos: newCombos,
      }),

    addCombo: (combo: any) =>
      set((state) => ({
        combos: [...state.combos, combo],
      })),

    clearCombos: () =>
      set({
        combos: [],
      }),

    setCompletedCombos: (completedCombos: any[]) =>
      set({
        completedCombos,
      }),

    setToCompleteCombos: (toCompleteCombos: any[]) =>
      set({
        toCompleteCombos,
      }),

    setOriginalCombos: (originalCombos: any[]) =>
      set({
        originalCombos,
      }),

    clearAll: () =>
      set({
        completedCombos: [],
        toCompleteCombos: [],
        originalCombos: {},
        combos: [],
      }),
  })
)

export default useSuggestedComboStore;
